export default __webpack_public_path__ + "static/media/header_payment.53671ba2.jpg";